<template>
  <div>
    <div class="row"></div>
    <table class="highlight">
      <thead>
        <tr>
          <th></th>
          <th>{{ $t('management.organisation') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="org in organisations" :key="'org' + org.id" @click="edit(org.id)" style="cursor: pointer">
          <td class="icons"></td>
          <td>{{ org.name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import organisationsApi from '../../../services/api/OrganisationsApi'
import router from '../../../router'

export default {
  name: 'Organisations',
  components: {},
  props: {},
  data () {
    return {
      organisations: [],
      showAddUser: false,
      showEditUser: false,
      selectedOrganisationId: null,
      selectedUser: {}
    }
  },
  computed: {
    formattedOrganisations () {
      return this.organisations
        .map(o => ({
          id: o.OrganisationId,
          name: o.OrganisationName
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1))
    }
  },
  watch: {},
  mounted () {
    this.getAllOrganisations()
  },
  methods: {
    getAllOrganisations () {
      organisationsApi.getOrganisations()
        .then(result => {
          this.organisations = result.data
        })
    },
    edit (id) {
      router.push('/organisations/' + id)
    }
  }
}
</script>

<style scoped>
  .title {
    font-size: x-large;
    font-weight: bold;
    padding: 1rem
  }

  table {
    margin: -1rem 1rem;
    width: 95%;
  }

  .icons>*{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/usermanagement/organisations/OrganisationList.vue